export default __webpack_public_path__ + "static/media/(30).bf5232b8.jpeg";